module.exports = __webpack_public_path__ + "media/images/logo-965467ab.svg";